import { CImage } from './CImage.js';

const CImagePlugin = {
    install: (app) => {
        app.component(CImage.name, CImage);
    },
};

export { CImage, CImagePlugin };
//# sourceMappingURL=index.js.map
